module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('article', {
    staticClass: "is-parent"
  }, [_c('img', {
    staticClass: "team_logo image is-96x96",
    attrs: {
      "src": _vm.Team.logo
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title has-text-centered"
  }, [_vm._v(_vm._s(_vm.Team.name))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "segment"
  }, [_c('player-card', {
    attrs: {
      "playerData": _vm.forwards,
      "heading": "Forwards",
      "redirect": "/season-stats/player-stats/",
      "logo": _vm.Team.logo
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('div', {
    staticClass: "segment"
  }, [_c('player-card', {
    attrs: {
      "playerData": _vm.defense,
      "heading": "Defense",
      "redirect": "/season-stats/player-stats/",
      "logo": _vm.Team.logo
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "segment"
  }, [_c('player-card', {
    attrs: {
      "playerData": _vm.goaltending,
      "heading": "Goaltending",
      "redirect": "/season-stats/player-stats/",
      "logo": _vm.Team.logo
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d15bd2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/teams/players.vue
// module id = 630
// module chunks = 30